import { initContract } from '@ts-rest/core'
import { paymentCustomersContract } from './customers.contract'
import { paymentMigrationContract } from './migration.contract'
import { paymentPaymentsContract } from './payments.contract'
import { paymentStripeContract } from './providers/stripe.contract'
import { paymentRefundsContract } from './refunds.contract'

const c = initContract()

export const paymentServiceContract = c.router(
  {
    customers: paymentCustomersContract,
    payments: paymentPaymentsContract,
    refunds: paymentRefundsContract,
    stripe: paymentStripeContract,
    migration: paymentMigrationContract,
  },
)
